import React, { memo, useContext } from 'react';


import { validators } from 'components/Form/validators';
import { Column } from 'components/Layout/Grid';
import { FailContext } from 'components/Form';
import Text from 'components/Text';
import { IRadioInput } from './interface';

import './styles.scss';

const RadioInput = (props: IRadioInput | any) => {
  const { id, children, checked, classname, title, name, value, required, stateName, showError = true, ...rest } = props;

  const fail = useContext(FailContext);

  const isValid = () => {
    if (validators.radio) {
      return validators.radio(name, required);
    }

    return true;
  };

  return (
    <Column className="flex-1">
      <label id={`LABEL_${id}`} htmlFor={id} className={`container ${classname}`}>
        <input
          type="radio"
          title={title || ''}
          defaultChecked={checked}
          value={value}
          name={name}
          required={required}
          data-statename={stateName}
          id={id}
          {...rest}
        />
        <div className="checkmark">
          <div className={checked ? 'checked animated bounceIn' : ''} />
        </div>
        {children && <span>{children}</span>}
      </label>

      {showError && isValid() && fail && (
        <Text size={12} className="animated fadeIn mt-1 color-danger position-alert">
          {isValid()}
        </Text>
      )}
    </Column>
  );
};

export default memo(RadioInput);
